import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentAsync, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { compare, resolveContent } from '@nu-art/ts-common';
export class PanelBaseSync extends ComponentSync {
    shouldAlwaysReDerive = false;
    deriveStateFromProps(nextProps) {
        return { config: { ...nextProps.config } };
    }
    shouldReDeriveState(nextProps) {
        return this.shouldAlwaysReDerive || !compare(this.state.config, nextProps.config);
    }
}
export class PanelBaseAsync extends ComponentAsync {
    async deriveStateFromProps(nextProps) {
        return { config: { ...nextProps.config } };
    }
    shouldReDeriveState(nextProps) {
        return !compare(this.state.config, nextProps.config);
    }
}
export class PanelParentSync extends PanelBaseSync {
    renderPanel(panel) {
        const ComponentToRender = resolveContent(this.props.instances?.[panel.key], panel.data, this.props.onConfigChanged);
        if (ComponentToRender) {
            this.shouldAlwaysReDerive = true;
            return ComponentToRender;
        }
        const PanelRenderer = this.props.renderers[panel.key];
        return _jsx(PanelRenderer, { config: panel.data, instances: this.props.instances, renderers: this.props.renderers, onConfigChanged: this.props.onConfigChanged });
    }
}
export class PanelParentAsync extends PanelBaseAsync {
    renderPanel(panel) {
        const ComponentToRender = resolveContent(this.props.instances?.[panel.key], panel.data, this.props.onConfigChanged);
        if (ComponentToRender)
            return ComponentToRender;
        const PanelRenderer = this.props.renderers[panel.key];
        if (!PanelRenderer)
            return `NO RENDERER DEFINED FOR KEY: ${panel.key}`;
        return _jsx(PanelRenderer, { config: panel.data, renderers: this.props.renderers, instances: this.props.instances });
    }
}
//# sourceMappingURL=Panels.js.map